import { ReactNode } from 'react';
import ClipboardButton from 'react-clipboard.js';
import styled, { css } from 'styled-components';

import { colors } from 'theme/theme';

const shareButtonCss = css`
  align-items: center;
  background-color: ${colors.lightContentGrey};
  border-radius: 50%;
  color: white;
  cursor: pointer;
  display: flex;
  height: 48px;
  justify-content: center;
  text-decoration: none;
  width: 48px;

  &:hover,
  &:focus {
    background-color: ${colors.hoverBlue};
    text-decoration: none;
    color: white;
  }
`;

export const ShareStyleButton = styled.a`
  ${shareButtonCss}
`;

export const StyledClipboardButton = styled(ClipboardButton)<{
  children: ReactNode;
}>`
  ${shareButtonCss}
`;
